// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/reeferhistory.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/drystatus.cs.d.ts" />
import * as React from 'react';
//import Bing from '../../actions/ReeferMapCallout.js';
//import * as ReeferMapjs from '../../actions/ReeferMapCallout.js';
//var Bing = ReeferMapjs.default;
import MapCallout from '../../actions/MapCallout';
import { AgGridReact } from 'ag-grid-react';
import Formatters from '../../actions/Formatters';
import DryFormatters from '../../actions/DryFormatter';
import { DryCellRenderer } from '../../actions/DryCellRenderer';
import $ from 'jquery';

import DateFormat from 'dateformat';
import moment from 'moment';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGConfirmWindow from '../sharedcomponents/ConfirmationWindow';
import { GridToolBarExcel } from '../sharedcomponents/GridToolBarExcel';
import lodashfilter from 'lodash/filter';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
//import '../../../node_modules/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css';
var Config: any = require('../../Config.json');

export interface DryGridState {
    rowData: DryUnitHistoryUI[],
    columnDefs: any[],
    Filters: DryHistoryFilter,
    mapState: string,
    overlayLoadingTemplate: any,
    pageSize: any,
    gridApiParams: any,
    PreferenceDTTM: any,
    selectedDataItems: any[],
    IsLocationEstimated: boolean,
    DashboardPreferenceId: any;
    DashboardWidgetsSearch: any[];
    IsReadOnly: any;
    RevisionNum: any;
    geoZonesEnabled: boolean;
    geoZonesImage: boolean;
}

var self;
var reeferCurrentStatus;
var selectedReefer = [];
var coppiedData;
var coppiedDataWithHeader;
var functionId;
var columnDefs2: any[];
var columnDefs: any[];
var dryAssetSensors: any[];

export class DryMapGrid extends React.Component<any, DryGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.initHistoryFilters();//new DryHistoryFilter();
        functionId = 49; // functionId for DryHistory Grid
        //var columnDefs = this.createColumnDefs();
        columnDefs2 = this.createColumnDefs();

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetCustomerDeviceTypeSensor');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.renderCustomerDeviceTypeSensorColumns(data);
            });
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        reeferCurrentStatus = [];
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        if (this.props.historyData != undefined && this.props.historyData != null) {
            reeferCurrentStatus.push(this.props.historyData[0]);
            this.state = {
                rowData: this.props.historyData[0],
                columnDefs: [],
                Filters: filterSet,
                mapState: "CurrentLocation",
                overlayLoadingTemplate: overlayTemplate,
                pageSize: 25,
                gridApiParams: [],
                PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
                selectedDataItems: [],
                IsLocationEstimated: false,
                DashboardWidgetsSearch: [],
                IsReadOnly: false,
                DashboardPreferenceId: 0,
                RevisionNum: 0,
                geoZonesEnabled: true,
                geoZonesImage: true
            };
        }
        else
            this.state = {
                rowData: [], columnDefs: [], Filters: filterSet, mapState: "CurrentLocation", overlayLoadingTemplate: overlayTemplate
                , pageSize: 25
                , gridApiParams: []
                , PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm)
                , selectedDataItems: []
                , IsLocationEstimated: false
                , DashboardWidgetsSearch: []
                , IsReadOnly: false
                , DashboardPreferenceId: 0
                , RevisionNum: 0
            };
        //this.PopulateReeferenceData();//WI-21810:QA_IE_Event description is displayed as 'NA' in reefer map screen
        this.GetDefaultGridPreferenceColumns();
        this.populateDefaultDates();
        self = this;
    }
        
    GetDefaultGridPreferenceColumns() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {
                    var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    if(defaultPreferenceName.length>0)                    
                        this.setState({ DashboardPreferenceId: defaultPreferenceName[0].DashboardPreferenceId, IsReadOnly: defaultPreferenceName[0].IsReadOnly, RevisionNum: defaultPreferenceName[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    else {
                        var dashboardLayouts: any = data.DashboardLayouts;
                        this.setState({ DashboardPreferenceId: dashboardLayouts[0].DashboardPreferenceId, IsReadOnly: dashboardLayouts[0].IsReadOnly, RevisionNum: dashboardLayouts[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    }
                }                
         });              
    }

    initHistoryFilters() {
        var dryHistoryFilter = new DryHistoryFilter();
        dryHistoryFilter.AssetNumber = '';
        dryHistoryFilter.DeviceNumber = '';
        dryHistoryFilter.EventCode = '';
        dryHistoryFilter.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        dryHistoryFilter.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');

        return dryHistoryFilter;
    }

    renderCustomerDeviceTypeSensorColumns(customerDeviceTypeSensor: any) {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];
        if (customerDeviceTypeSensor != null && customerDeviceTypeSensor != undefined)
            dryAssetSensors = customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'D');

        if (dryAssetSensors != null && dryAssetSensors != undefined && dryAssetSensors.length > 0) {
            //var door1Column = { headerName: "Door", field: "Door1Open", cellRenderer: DryFormatters.doorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) };
            //generatedColumns.push(door1Column);

            $.each(dryAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });

            var newColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }

    populateDefaultDates() {
        var toDTTM = this.state.PreferenceDTTM;
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
    }

    onGridReady(params: any) {
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
        //this.gridApi.sizeColumnsToFit();
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        var gridPreferencesData: any = self.state.DashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 17);
        self.setState({ gridApiParams: params.api });
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        //GridPreferenceControl.HistoryGridPreferenceColumns(functionId, params.api);
        setTimeout(() => {
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, params.api, gridPreferencesData, "DryMap");
        }, 3000);
    }

    refreshGrid = () => {
        if (this.state.mapState == "DryTrace") {
            this.populateSelectedReefersDates();
            this.bindDryHistoryData();
            MapCallout.UpdateGensetGridName("DryTrace");
        }
        else {
            this.populateDefaultDates();
            this.bindReeferCurrentData();
            MapCallout.UpdateGensetGridName("dry");
        }
    };

    onGridSelectionChanged(params: any) {
        self.setState({ IsLocationEstimated: false });
        var selectedRows = params.api.getSelectedRows();
        if (selectedRows != null && selectedRows != undefined) {
            if (self.state.mapState == "CurrentLocation") {
                //selectedRows.forEach(function (selectedRow, index) {
                //    MapCallout.DisplayDrySelectedPushpin(selectedRow);
                //    selectedReefer = [];
                //    selectedReefer.push(selectedRow);
                //});
                setTimeout(() => { self.showSelectedPushin(selectedRows); }, 500);//RCNG-1355
            }
            else
                self.BindMapPushPin(selectedRows);

            self.setState({
                selectedDataItems: selectedRows
            });
        }
    }

    showSelectedPushin(selectedRows: any) {
        selectedRows.forEach(function (selectedRow, index) {
            MapCallout.DisplayDrySelectedPushpin(selectedRow);
            selectedReefer = [];
            selectedReefer.push(selectedRow);
        });
    }

    BindMapPushPin(selectedRows: any) {
        var selectedRowsWithCoords = lodashfilter(selectedRows, function (item) {
            return item.GPSCoords != null && item.GPSCoords != undefined && item.GPSCoords.toString() != "";
        });
        if (selectedRowsWithCoords != null && selectedRowsWithCoords.length > 0)
            MapCallout.DisplayDrySelectedPushpin(selectedRowsWithCoords[0]);
        else {
            if (self.state.rowData != null && self.state.rowData != undefined && self.state.rowData.length > 0) {
                var selectedRowIndex = self.state.rowData.findIndex(row => row.DCHistoryID === selectedRows[0].DCHistoryID);
                if (selectedRowIndex != -1) {
                    if (selectedRowIndex == self.state.rowData.length - 1) {
                        MapCallout.DisplayDrySelectedPushpin(selectedRows[0]);
                    }
                    else {
                        for (var rowIndex = selectedRowIndex + 1; rowIndex < self.state.rowData.length; rowIndex++) {
                            var rowCurrentData = self.state.rowData[rowIndex];
                            if (rowCurrentData.GPSCoords != null && rowCurrentData.GPSCoords != undefined && rowCurrentData.GPSCoords.toString() != "") {
                                self.setState({ IsLocationEstimated: true });
                                selectedRows[0].Latitude = rowCurrentData.Latitude;
                                selectedRows[0].Longitude = rowCurrentData.Longitude;
                                MapCallout.DisplayDrySelectedPushpin(selectedRows[0]);
                                break;
                            }
                            else if (rowIndex == self.state.rowData.length - 1) {
                                MapCallout.DisplayDrySelectedPushpin(selectedRows[0]);
                            }
                        }
                    }
                }
            }
        }
    }

    FromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            Filters: filters
        });
    }

    ToDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            Filters: filters
        });
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    populateSelectedReefersDates() {
        if (selectedReefer[0].EventDTTM != null && selectedReefer[0].EventDTTM != "") {
            //var toDTTM = DateFormat(new Date(selectedReefer[0].EventDTTM), 'mm/dd/yyyy');
            var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
            var currenttoDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
            var toDTTM = Formatters.DateTimeFormatter(selectedReefer[0].EventDTTM);
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
            this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        }
        else {
            var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
            var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        }
        self.state.Filters.AssetNumber = selectedReefer[0].AssetMasterID;
        self.state.Filters.DeviceNumber = selectedReefer[0].DeviceNumber;
        self.state.Filters.EventCode = selectedReefer[0].EventCode;
        //var CurrentReefers = "";
        //var CurrentReefersList = [];
        //reeferCurrentStatus[0].forEach(function (item, index) {
        //    CurrentReefersList.push(item.UnitMasterID);
        //});

        //CurrentReefers = CurrentReefersList.join(",");
        //this.state.Filters.Units = CurrentReefers;
    }

    bindDryHistoryData() {
        self.state.gridApiParams.showLoadingOverlay();
        MapCallout.ClearMapPushpins();
        self.setState({ IsLocationEstimated: false });
        var fromDate = moment(new Date(this.state.Filters.FromDate)).startOf('day').toString();
        var toDate = moment(new Date(this.state.Filters.ToDate)).endOf('day').toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<DryUnitHistoryUI[]>)
            .then(data => {
                if (data.length > 0) {
                    MapCallout.BindDryTraceMapPushpins(data, "dryTrace");
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                }

                this.setState({
                    rowData: data
                });
                self.state.gridApiParams.paginationGoToFirstPage();
                self.state.gridApiParams.hideOverlay();
            });
    }
    onCellClickedCopy(event) {
        coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        coppiedData = event.value;
    }

    bindReeferCurrentData() {
        $('#globalLoader').show();
        var CurrentReefers = "";
        var CurrentReefersList = [];
        reeferCurrentStatus[0].forEach(function (item, index) {
            CurrentReefersList.push(item.AssetNumber);
        });

        CurrentReefers = CurrentReefersList.join(",");
        var reeferSearchFilters: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedReefer: CurrentReefers, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '',
            CustomAttributeFilters: null, SelectedAssetTypes: '', SelectedAssetStates: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedVoyage: '', SelectedCall: '', SelectedCargoCareProfiles: '',
            SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: [] 

        };//WI-26881
        //var filterset: server.AdvancedGensetSearchFilters = {
        //    CustomerTypeCode: null, CustomerID: null, AssetType: null, AssetNumber: self.state.Filters.AssetNumber, ServerFence: null, DeviceFence: null, Region: null, City: null, State: null, ZipCode: null, Country: null, Geofence: null, POI: null, Oem: null, ReportingInterval: null, GeofenceInside: null
        //};
        //var filterParams = JSON.stringify(filterset);
        var filterParams = JSON.stringify(reeferSearchFilters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryStatusDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(response => response.json() as Promise<DryMasterStatus[]>)
            .then(data => {
                self.setState({
                    rowData: data
                });

                self.state.gridApiParams.paginationGoToFirstPage();
                if (data.length > 0) {
                    MapCallout.BindDryTraceMapPushpins(data, "Dry");
                    MapCallout.DisplayDrySelectedPushpin(data[0]);
                }
                $('#globalLoader').hide();
            });
    }

    ApplyDryHistorySearch() {
        var message = this.ValidateHistoryDates();
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        self.state.gridApiParams.showLoadingOverlay();
        MapCallout.ClearMapPushpins();
        self.setState({ IsLocationEstimated: false });
        var fromDate = moment(new Date(this.state.Filters.FromDate)).startOf('day').toString();
        var toDate = moment(new Date(this.state.Filters.ToDate)).endOf('day').toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<DryUnitHistoryUI[]>)
            .then(data => {
                if (data.length > 0) {
                    MapCallout.BindDryTraceMapPushpins(data, "dryTrace");
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                    self.state.gridApiParams.paginationGoToFirstPage();
                    self.state.gridApiParams.hideOverlay();
                }
                this.setState({
                    rowData: data
                });
            });
    }

    ValidateHistoryDates() {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        //var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = this.state.Filters.FromDate;
        var toDttm = this.state.Filters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    createColumnDefs() {
        return [
            {
                headerName: 'State Indicators',
                children: [
                    { headerName: "PWR", field: "DryPWR", width: 70, cellRenderer: DryCellRenderer.PwrStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BATT", field: "BatteryPct", cellRenderer: DryCellRenderer.BatteryPctFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: DryCellRenderer.StringTypeFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "TRIP", field: "TripStatusCdAndDFlag", tooltipField: "TripNameAndStatus", width: 70, cellRenderer: DryCellRenderer.TripstatusIndicator, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: "Latest Event",
                children: [
                    { headerName: "Dry ID", field: "AssetNumber", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Event", field: "EventDescription", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, enableTooltip: true, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                ]
            },
            {
                headerName: 'Last Reported Device Data',
                children: [
                    { headerName: "Door", field: "Door1Open", cellRenderer: DryFormatters.doorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "Door1EventDttm", cellRenderer: Formatters.dateTypeFormatter, width: 170, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {headerName: "Inside temp ", field: "InsideTemp", headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "InsideTemp"); }, cellRenderer: DryFormatters.TemperatureValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)},                    
                    //{ headerName: "Device Data Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DeviceDataTime", cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Possible damage", field: "PossibleDamage",
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PossibleDamage"); }, cellRenderer: DryCellRenderer.PossibleDamageFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Device fence", field: "FenceName", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device fence ID", field: "FenceNameID", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence", field: "BackendGeofenceName", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence ID", field: "BackendGeofenceNameID", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    // { headerName: "Region Fence", field: "RegionGeofence", cellRenderer: DryCellRenderer.StringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    // { headerName: "Region Fence ID", field: "RegionGeofenceName", cellRenderer: DryCellRenderer.StringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Geofence fevision", field: "GeofenceDefinitionRevision", cellRenderer: Formatters.floatTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Address", field: "Address", cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "City", field: "City", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "State", field: "State", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Country", field: "Country", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Zip", field: "ZipCode", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Battery (V)", field: "DeviceBattery", cellRenderer: Formatters.BattVoltageFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc coords", field: "GPSCoords", valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, cellRenderer: DryCellRenderer.GPSCoordsFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", cellRenderer: Formatters.secondsToTimeConverter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc acc (m)", field: "PositionAccuracy", valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSAcctypeSorting(params.data.PositionAccuracy); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc HDOP", field: "DryGPSHDOP", valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSHDOPTypeSorting(params.data.DryGPSHDOP, params.data.GPSLockState); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc sat ct", field: "DryGPSSatelliteCount", valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSSatCountTypeSorting(params.data.DryGPSSatelliteCount, params.data.GPSLockState); }, cellRenderer: DryCellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MCC (country)", field: "CountryName", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MNC", field: "MNC", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Tower ID", field: "TowerBaseStationID", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device ID", field: "RCDID", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device FW", field: "FirmwareVersion", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device bat (V)", field: "BattVoltage", cellRenderer: Formatters.BattVoltageFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Lux", field: "Illumination", cellRenderer: Formatters.LuxValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Bat mode", field: "BatteryMode", valueGetter: (params) => { return Formatters.BatteryModeFormatter(params); }, cellRenderer: Formatters.BatteryModeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },                    
                    { headerName: "Door bat", field: "Door1BattPct", cellRenderer: DryCellRenderer.DoorBattPctFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MSISDN", field: "MSISDN", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "IMSI", field: "SIM_IMSI", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "ICCID", field: "ICCID", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "EUI", field: "EUI", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Cell signal", field: "RSSI", cellRenderer: DryCellRenderer.RSSITypeFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Speed", field: "DrySpeed", headerValueGetter: Formatters.SpeedHeaderFormatter, cellRenderer: DryFormatters.SpeedConverter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Miles", field: "Miles", cellRenderer: Formatters.floatTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device type", field: "DeviceType", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CreatedDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", cellRenderer: DryCellRenderer.StringTypeFormatter, width: 180, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Device Gravity Vector Status',
                children: [
                    { headerName: "X Axis", field: "XAxis", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "XAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 180 },
                    { headerName: "Y Axis", field: "YAxis", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "YAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 180 },
                    { headerName: "Z Axis", field: "ZAxis", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ZAxis"); }, cellRenderer: Formatters.GravityVectorValueFormatter, width: 180 }
                ]
            }
        ];
    }

    updateReeferMapDimensions() {
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 401);
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 401);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateReeferMapDimensions.bind(this));
    }

    radioButtonChange(value) {
        if (value == "DryTrace") {
            $('#geoZones').hide();
            this.populateSelectedReefersDates();
            this.bindDryHistoryData();            
            this.setState({ mapState: value });
            MapCallout.UpdateGensetGridName("DryTrace");            
            document.getElementById("lblCurrentLocation").classList.remove("active");
            document.getElementById("lblDryTrace").classList.add("active");
        }
        else {
            $('#geoZones').show();  
            this.populateDefaultDates();
            this.bindReeferCurrentData();         
            this.setState({ mapState: value });
            MapCallout.UpdateGensetGridName("dry");           
            document.getElementById("lblDryTrace").classList.remove("active");
            document.getElementById("lblCurrentLocation").classList.add("active");
        }
    }

    ShowFullMap() {
        $("#Container1").hide();
        $("#Container2").hide();
        $("#Container3").hide();
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 102);
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 102);
        $("#reeferMapGrid-height").css("border", "none");
        $("#dvFullScreen").css("display", "none");
        $("#dvResizeScreen").css("display", "block");
        $('.ReeferMapCallout').addClass('m-2');
        $('#geoZones').removeClass('dryMap-geoZones');
        $('#geoZones').addClass('dryMap-geoZones-fullScreen');
    }

    MinimizeMap() {
        $("#Container1").show();
        $("#Container2").show();
        $("#Container3").show();
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 401);
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 401);
        $("#reeferMapGrid-height").css("border", "1px solid #045976");
        $("#dvFullScreen").css("display", "block");
        $("#dvResizeScreen").css("display", "none");
        $('.ReeferMapCallout').removeClass('m-2');
        $('#geoZones').removeClass('dryMap-geoZones-fullScreen');
        $('#geoZones').addClass('dryMap-geoZones');
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    navigateToNextCell(params: any) {
        var previousCell = params.previousCellDef;
        var suggestedNextCell = params.nextCellDef;

        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        switch (params.key) {
            case KEY_DOWN:
                previousCell = params.previousCellDef;
                // set selected cell on current cell + 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_UP:
                previousCell = params.previousCellDef;
                // set selected cell on current cell - 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_LEFT:
            case KEY_RIGHT:
                return suggestedNextCell;
            default:
                throw "this will never happen, navigation is always on of the 4 keys above";
        }
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function (item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function () {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "DryMap");
            },
        });
        return finalMenuItem;
    }

    validateRevisionNum(dashboardPreferenceId: any) {
        var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
        RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNumConfirm.bind(this, dashboardPreferenceId), self.closeRevisionConfirmation.bind(this));
    }

    refreshRevisionNumConfirm(dashboardPreferenceId: any) {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {                    
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    this.setState({ RevisionNum: defaultPreferenceName[0].RevisionNum  });
                }            
                $('#globalLoader').hide();   
            });
    }

    refreshRevisionNum(dashboardPreferenceId: any) {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {                    
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    this.setState({ RevisionNum: defaultPreferenceName[0].RevisionNum  });
                }            
            });
    }
    closeRevisionConfirmation() {
        RCNGConfirmWindow.ConfirmWindow.close();
    }

    public render() {
        return <div>
            <div className='page-controls-container' id="Container1">
                <div className='row'>
                    <div className='col-lg-7'>

                        <div className="btn-group btn-group-dsd" role="group" aria-label="Basic radio toggle button group">
                            <input type="radio" className="btn-check" value="CurrentLocation" name="GroupType" checked={this.state.mapState == 'CurrentLocation'} />
                            <label id="lblCurrentLocation" className="btn btn-outline-secondary" onClick={(e) => this.radioButtonChange('CurrentLocation')}> Current Location </label>

                            <input type="radio" className="btn-check" value="DryTrace" name="GroupType" checked={this.state.mapState == 'DryTrace'} />
                            <label id="lblDryTrace" className="btn btn-outline-secondary" onClick={(e) => this.radioButtonChange('DryTrace')}> Dry Trace </label>

                        </div>

                    </div>

                    <div className="col-md-5" >
                        <div className="input-group from-to-calender">
                            <span className="input-group-text">From</span>

                            <DatePicker
                                selected={new Date(this.state.Filters.FromDate)}
                                maxDate={new Date(this.state.PreferenceDTTM)}
                                onChange={this.FromDateChange.bind(this)}
                                timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
                                dateFormat="MM/dd/yyyy hh:mm aa"
                                showTimeInput
                                className=""
                                id="dtFromDate"
                            />

                            <span className="input-group-text">To</span>

                            <DatePicker
                                selected={new Date(this.state.Filters.ToDate)}
                                maxDate={new Date(this.state.PreferenceDTTM)}
                                onChange={this.ToDateChange.bind(this)}
                                timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
                                dateFormat="MM/dd/yyyy hh:mm aa"
                                showTimeInput
                                className=""
                                id="dtToDate"
                            />



                            {
                                this.state.mapState == 'CurrentLocation' ?
                                    <button type='button' disabled={this.state.mapState == 'CurrentLocation'} className='btn btn-primary'>Search</button>
                                    :
                                    <button type='button' disabled={this.state.mapState == 'CurrentLocation'} onClick={this.ApplyDryHistorySearch.bind(this)} className='btn btn-primary'>Search</button>
                            }

                        </div>
                    </div>

                </div>
            </div>
            <div id="Container3">
                {
                    this.state.mapState == 'CurrentLocation' ?
                        <GridToolBarExcel refreshGrid={this.refreshGrid.bind(this)}
                            gridData={this.state.rowData}
                            gridApiParams={this.state.gridApiParams}
                            colDefs={this.state.columnDefs}
                            colDefs2={columnDefs2}
                            parentchild={"C"}
                            formName={"DryMap"}
                            functionId={"49"}
                            sensorData={dryAssetSensors}
                            isHistory={"False"} 
                            widgetId={17} 
                            dashboardPreferenceId = {this.state.DashboardPreferenceId}
                            isReadOnly={this.state.IsReadOnly}
                            revisionNum={this.state.RevisionNum}
                            validateRevisionNum={this.validateRevisionNum.bind(this)}
                            refreshRevisionNum={this.refreshRevisionNum.bind(this)}
                            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}/>
                        :
                        <GridToolBarExcel refreshGrid={this.refreshGrid.bind(this)}
                            gridData={this.state.rowData}
                            gridApiParams={this.state.gridApiParams}
                            colDefs={this.state.columnDefs}
                            colDefs2={columnDefs2}
                            parentchild={"C"}
                            formName={"DryMap"}
                            functionId={"49"}
                            sensorData={dryAssetSensors}
                            isHistory={"True"} 
                            widgetId={17} 
                            dashboardPreferenceId = {this.state.DashboardPreferenceId}
                            isReadOnly={this.state.IsReadOnly}
                            revisionNum={this.state.RevisionNum}
                            validateRevisionNum={this.validateRevisionNum.bind(this)}
                            refreshRevisionNum={this.refreshRevisionNum.bind(this)}
                            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}/>
                }
            </div>
            <div className='row' id="Container2">
                <div className='col-lg-12'>
                    <div className="ag-theme-fresh reeferMapGrid-height">
                        <AgGridReact
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            onGridReady={this.onGridReady}
                            pagination={true}
                            rowSelection={'single'}
                            accentedSort={true}
                            onSelectionChanged={this.onGridSelectionChanged}
                            onPaginationChanged={this.onPaginationPageLoaded}
                            paginationPageSize={this.state.pageSize}
                            navigateToNextCell={this.navigateToNextCell}
                            getMainMenuItems={this.getMainMenuItems.bind(this)}
                            onDragStopped={this.onSavecolumnorder.bind(this)}
                            overlayLoadingTemplate={this.state.overlayLoadingTemplate}>
                        </AgGridReact>
                    </div>
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className='row' id="Container3">
                <div className='col-lg-12 position-relative'>
                    <div id="dvFullScreen" onClick={this.ShowFullMap.bind(this)} className='map-full-screen'>
                        <span className='fa-solid fa-expand'></span>
                    </div>
                    <div id="dvResizeScreen" onClick={this.MinimizeMap.bind(this)} className='map-half-screen'>
                        <span className='fa-regular fa-compress'></span>
                    </div>
                    <div id='reeferMapGrid-height' className='ReeferMapCallout'></div>
                    <div id='geoZones' className='dryMap-geoZones'>                    
                    {
                            this.state.geoZonesEnabled == true ? <span title='Show Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon opacity-25" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.showGeoZonesLayer.bind(this)}></span>
                                : <span title='Hide Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.hideGeoZonesLayer.bind(this)}></span>
                    }
                    </div>
                    {this.state.IsLocationEstimated == true ? <div className='ReeferMapGridEstimated'>Location estimated</div> : ''}
                </div>
            </div>
        </div>;
    }

    showGeoZonesLayer() {
        this.setState({ geoZonesEnabled: false });
        MapCallout.BindGeoZonesLayer();
    }

    hideGeoZonesLayer() {
        this.setState({ geoZonesEnabled: true });
        MapCallout.DisposeGeozonesLayer();
    }

    static UpdateFenceImage(src:any) {
        if (src == "A")
            self.setState({ geoZonesImage: false });
        else
            self.setState({ geoZonesImage: true });
    }

    public componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsForDrys('158');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            MapCallout.InitializeMap("reeferMapGrid-height");
            this.updateReeferMapDimensions();
            window.addEventListener("resize", this.updateReeferMapDimensions.bind(this));
            document.getElementById("lblDryTrace").classList.remove("active");
            document.getElementById("lblCurrentLocation").classList.add("active");

            $("#dvResizeScreen").css("display", "none");
            setTimeout(() => { this.loadTraceMapPushpins(); }, 500);

        }
    }

    loadTraceMapPushpins() {
        MapCallout.BindDryTraceMapPushpins(reeferCurrentStatus[0], "dry");
    }

    public componentDidUpdate() {
        if (this.state.mapState == 'CurrentLocation') {
            $('#dtFromDate *').attr('disabled', 'disabled');
            $('#dtToDate *').attr('disabled', 'disabled');
            $('#dtFromDate').css('pointer-events', 'none');
            $('#dtToDate').css('pointer-events', 'none');
        }
        else {
            $('#dtFromDate *').removeAttr('disabled');
            $('#dtToDate *').removeAttr('disabled');
            $('#dtFromDate').css('pointer-events', 'auto');
            $('#dtToDate').css('pointer-events', 'auto');
        }
    }
}

class DryHistoryFilter {
    AssetNumber: string;
    DeviceNumber: string;
    FromDate: string;
    ToDate: string;
    EventCode: string;
}

interface DryMasterStatus {
    DryCurrentConditionId: number;
    EventDTTM?: Date;
    StrEventDTTM: string;
    CreatedDTTM?: Date;
    EventDescription: string;
    AssetNumber: string;
    FenceName: string;
    BackendGeofenceName: string;
    RegionGeofence: string;
    RegionGeofenceName: string;
    GeofenceDefinitionRevision: string;
    City: string;
    State: string;
    Country: string;
    ZipCode: string;
    BattVoltage: number;
    GPSCoords: string;
    StrGPSDTTM: string;
    GPSHDOP: string;
    GPSSatelliteCount: string;
    CountryName: string;
    MNC: string;
    TowerLocalizationAreaCode: string;
    TowerBaseStationID: string;
    RCDID: string;
    FirmwareVersion: string;
    DeviceBattery: string;
    MSISDN: string;
    SIM_IMSI: string;
    ICCID: string;
    EUI: string;
    RSSI: string;
    Speed: number;
    DeviceConfig: string;
    DeviceType: string;
    RCDReportingInterval: string;
    CustomerName: string;
    ErrorMessage: string;
    AssetMasterID: number;
    Sensor1Value: number;
    Sensor2Value: number;
    Sensor3Value: number;
    Sensor4Value: number;
    Sensor5Value: number;
    Sensor6Value: number;
    Sensor7Value: number;
    Sensor8Value: number;
    PositionAccuracy?: number;
}
interface DryUnitHistoryUI {
    DCConditionLogID: number;
    EventDTTM?: Date;
    StrEventDTTM: string;
    Latitude?: number;
    Longitude?: number;
    EventCD: string;
    IsAlarm?: boolean;
    CreatedDTTM?: Date;
    RCDID: string;
    FirmwareVersion: string;
    EventDescription: string;
    AssetNumber: string;
    Speed?: number;
    GPSHDOP?: number;
    GPSSatelliteCount?: number;
    GPSLockState: string;
    GeofenceDefinitionRevision?: number;
    GPSDTTM?: Date;
    StrGPSDTTM: string;
    BattVoltage?: number;
    BackUpBattVoltage?: number;
    ExtBattVoltage?: number;
    LSCallFlag: string;
    BackendGeofenceName: string;
    RSSI?: number;
    ManufacturedDate?: Date;
    FenceID: string;
    FenceName: string;
    City: string;
    State: string;
    RegionGeofenceName: string;
    HasAlarm?: boolean;
    AlertCount?: number;
    ZipCode: string;
    Country: string;
    CustomerName: string;
    GPSCoords: string;
    AssetOemDsc: string;
    CountryName: string;
    MNC: string;
    TowerLocalizationAreaCode: string;
    TowerBaseStationID: string;
    RCDReportingInterval?: number;
    MSISDN: string;
    SIM_IMSI: string;
    ICCID: string;
    EUI: string;
    DeviceConfig?: boolean;
    DeviceType: string;
    CCSeverityLevelDC: string;
    VesselCd: string;
    GPSLastLock: string;
    FenceNameID: string;
    RegionGeofenceNameID: string;
    BackendGeofenceNameID: string;
    CommentExistsDC: string;
    AssetMasterID: number;
    Sensor1Value: number;
    Sensor2Value: number;
    Sensor3Value: number;
    Sensor4Value: number;
    Sensor5Value: number;
    Sensor6Value: number;
    Sensor7Value: number;
    Sensor8Value: number;
    BatteryPct: number;
}

